import {ActionList} from '@primer/react'

import type {SelectItemProps} from '../types'

export const SelectItem = ({ref, selected, ...props}: SelectItemProps & {ref?: React.Ref<HTMLLIElement> | null}) => {
  if (props.renderItem) {
    return props.renderItem({selected, ...props})
  }

  const {label, id, description, descriptionVariant, onSelect, renderDescription, className, trailingVisual, disabled} =
    props

  return (
    <ActionList.Item
      key={id}
      role="option"
      onSelect={() => {
        onSelect({label, id, selected, description, descriptionVariant})
      }}
      selected={selected}
      ref={ref}
      className={className}
      disabled={disabled}
    >
      {label}
      {(description || renderDescription) && (
        <ActionList.Description variant={descriptionVariant}>
          {renderDescription ? renderDescription() : description}
        </ActionList.Description>
      )}
      {trailingVisual ? <ActionList.TrailingVisual>{trailingVisual}</ActionList.TrailingVisual> : null}
    </ActionList.Item>
  )
}

SelectItem.displayName = 'SelectItem'
